/** @hidden */
export var useEditable = function useEditable(editable) {
  var context = {};
  var settings = editable !== undefined ? editable : context.editable || false;
  var edit = settings === true || settings !== undefined && settings !== false && settings.edit === true;
  var resize = settings === true || settings !== undefined && settings !== false && settings.resize === true;
  var remove = settings === true || settings !== undefined && settings !== false && settings.remove === true;
  var drag = settings === true || settings !== undefined && settings !== false && settings.drag === true;
  var add = settings === true || settings !== undefined && settings !== false && settings.add === true;
  var select = settings === true || settings !== undefined && settings !== false && settings.select === true;
  return {
    add: add,
    edit: edit,
    drag: drag,
    remove: remove,
    resize: resize,
    select: select
  };
};